import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StateSummaryService {
  constructor(private readonly http: HttpClient) {}
  getStateSummaryData(): Observable<any> {
    return this.http.get('assets/data/uim-ui/state-summary.json');
  }
}
